import { render, staticRenderFns } from "./ChatGroupMember.vue?vue&type=template&id=444822cc"
import script from "./ChatGroupMember.vue?vue&type=script&lang=js"
export * from "./ChatGroupMember.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupMember.vue?vue&type=style&index=0&id=444822cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports